import React from 'react';
import './style.scss';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const ColumnsSplitter = (props) => {
  if (!props.params) {
    return <GenericPlaceholder componentName="ColumnsSplitter" />;
  }
  const { Styles, ColumnWidth1, ColumnWidth2 } = props.params;
  const contentClass = !props?.params?.doNotAddMargins ?? 'content';
  const columns = props.params.EnabledPlaceholders?.split(',');
  if (columns.length === 2) {
    return (
      <div className={clsx(contentClass, 'columns-splitter', 'add-margins', Styles)}>
        <div className="row">
          {columns?.map((value, index) => (
            <div
              key={index}
              className={clsx(
                'columns-splitter-column',
                index === 0 && ColumnWidth1,
                index === 1 && ColumnWidth2,
                !ColumnWidth1 && !ColumnWidth2 && `col-md-${12 / columns.length} col-sm-12 `
              )}
            >
              <Placeholder name={`jss-column-${value}`} rendering={props.rendering} />
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className={clsx(contentClass, 'columns-splitter', 'add-margins', Styles)}>
        <div className="row">
          {columns?.map((value, index) => (
            <div
              key={index}
              className={`col-md-${12 / columns.length} col-sm-12 columns-splitter-column`}
            >
              <Placeholder name={`jss-column-${value}`} rendering={props.rendering} />
            </div>
          ))}
        </div>
      </div>
    );
  }
};

export default ColumnsSplitter;
